import { render, staticRenderFns } from "./ChatBotClientConfig.vue?vue&type=template&id=630abe8e"
import script from "./ChatBotClientConfig.vue?vue&type=script&lang=js"
export * from "./ChatBotClientConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports